import React, { useState, useEffect } from 'react';
import './Offers.css';
import upunion from '../assets/Union.svg';
import downunion from '../assets/Union (1).svg';

const mockCoupons = [
  {
    id: 1,
    code: 'FLIGHT20',
    discount: '20% OFF ON ALL INTERNATIONAL FLIGHTS',
    validUntil: '30/05/2024',
    details: [
      'Applicable on flight bookings above 1000 INR',
      'Flights from Vistara, Indigo and Asia air',
      'Not applicable for domestic',
    ],
  },
  {
    id: 2,
    code: 'FLIGHT30',
    discount: '30% OFF on round-trip bookings',
    validUntil: '01/06/2024',
    details: [
      'Valid on round trips only',
      'Only for bookings made via mobile app',
      'Not combinable with other offers',
    ],
  },
  {
    id: 3,
    code: 'FLIGHT10',
    discount: '10% Cashback on domestic flights',
    validUntil: '28/05/2024',
    details: [
      'Only for new users',
      'Valid once per user',
      'Max cashback: ₹200',
    ],
  },
];

const FlightDiscount = () => {
  const [activeSection, setActiveSection] = useState('Offers');
  const [activeTab, setActiveTab] = useState('All');
  const [expandedCoupon, setExpandedCoupon] = useState(null);
  const [coupons, setCoupons] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  const tabs = ['All', 'Available', 'Used', 'Expired'];

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const response = await fetch('https://your-backend-api.com/api/coupons');
        if (!response.ok) throw new Error('Failed to fetch');
        const data = await response.json();
        setCoupons(data);
      } catch (err) {
        console.error('Fetch failed, using mock data', err);
        setCoupons(mockCoupons);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCoupons();
  }, []);

  const toggleDetails = (id) => {
    setExpandedCoupon(expandedCoupon === id ? null : id);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCoupons = coupons.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(coupons.length / itemsPerPage);

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div>
      <div style={{ fontWeight: '500', fontSize: '250%' }}>Offers</div>

      <div className="tabs">
        <button
          className={`tab ${activeSection === 'Offers' ? 'tab-active' : ''}`}
          onClick={() => setActiveSection('Offers')}
        >
          Offers
        </button>
        <button
          className={`tab ${activeSection === 'Rewards' ? 'tab-active' : ''}`}
          onClick={() => setActiveSection('Rewards')}
        >
          Rewards
          <span className="offer-tooltip">Coming Soon</span>
        </button>
      </div>

      <div className="offer-container">
        <div className="tab-container">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`offer-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {isLoading ? (
          <div style={{ padding: '20px' }}>Loading coupons...</div>
        ) : (
          <div className="coupons-container">
            {currentCoupons.map((coupon) => (
              <div key={coupon.id} className="coupon">
                <div className="coupon-header">
                  <div className="coupon-code">{coupon.code}</div>
                  <div className="coupon-info">
                    <div className="coupon-discount">{coupon.discount}</div>
                    <div
                      className="details-button"
                      onClick={() => toggleDetails(coupon.id)}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '15px',
                      }}
                    >
                      <div className="coupon-corner">
                        {expandedCoupon === coupon.id ? (
                          <>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <div>Collapse Details</div>
                              <img src={upunion} alt="Collapse" />
                            </div>
                            <div className="coupon-details">
                              <ul>
                                {coupon.details.map((detail, index) => (
                                  <li key={index}>{detail}</li>
                                ))}
                              </ul>
                            </div>
                          </>
                        ) : (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <span>View Details</span>
                            <img src={downunion} alt="Expand" />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="valid-until">Valid until: {coupon.validUntil}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="pagination">
          <button
            className="pagination-button"
            onClick={() => changePage(1)}
            disabled={currentPage === 1}
          >
            &lt;&lt;
          </button>
          <button
            className="pagination-button"
            onClick={() => changePage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            &lt;
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              className={`pagination-button ${currentPage === index + 1 ? 'active-page' : ''}`}
              onClick={() => changePage(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            className="pagination-button"
            onClick={() => changePage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
          <button
            className="pagination-button"
            onClick={() => changePage(totalPages)}
            disabled={currentPage === totalPages}
          >
            &gt;&gt;
          </button>
        </div>

        {error && (
          <div style={{ color: 'red', marginTop: '10px' }}>
            Could not fetch data from backend. Showing mock data.
          </div>
        )}
      </div>
    </div>
  );
};

export default FlightDiscount;
